import http from 'hub-http/clients/apiClient';
const API_BASE = 'sso/v1';
export default class SingleSignonAPI {
  static getSamlSettings() {
    return http.get(`${API_BASE}/saml/settings/sso-settings`);
  }
}